"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.db = void 0;
var EntityManagerFactory_1 = require("./EntityManagerFactory");
exports.db = (function () {
    var emf = new EntityManagerFactory_1.EntityManagerFactory();
    var bq = emf.createEntityManager(true);
    Object.assign(bq, {
        configure: function (options) {
            emf.configure(options);
            return this;
        },
        connect: function (hostOrApp, secure, doneCallback, failCallback) {
            if (secure instanceof Function) {
                return this.connect(hostOrApp, undefined, secure, doneCallback);
            }
            emf.connect(hostOrApp, secure);
            return this.ready(doneCallback, failCallback);
        },
    });
    return bq;
})();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFxZW5kLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYmFxZW5kLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLCtEQUE4RDtBQThCakQsUUFBQSxFQUFFLEdBQUcsQ0FBQztJQUNqQixJQUFNLEdBQUcsR0FBRyxJQUFJLDJDQUFvQixFQUFFLENBQUM7SUFDdkMsSUFBTSxFQUFFLEdBQUcsR0FBRyxDQUFDLG1CQUFtQixDQUFDLElBQUksQ0FBQyxDQUFDO0lBRXpDLE1BQU0sQ0FBQyxNQUFNLENBQUMsRUFBRSxFQUFFO1FBQ2hCLFNBQVMsWUFBZSxPQUFPO1lBQzdCLEdBQUcsQ0FBQyxTQUFTLENBQUMsT0FBTyxDQUFDLENBQUM7WUFDdkIsT0FBTyxJQUFJLENBQUM7UUFDZCxDQUFDO1FBRUQsT0FBTyxZQUFlLFNBQWlCLEVBQUUsTUFBMkIsRUFBRSxZQUFrQixFQUFFLFlBQWtCO1lBQzFHLElBQUksTUFBTSxZQUFZLFFBQVEsRUFBRTtnQkFDOUIsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFDLFNBQVMsRUFBRSxTQUFTLEVBQUUsTUFBTSxFQUFFLFlBQVksQ0FBQyxDQUFDO2FBQ2pFO1lBRUQsR0FBRyxDQUFDLE9BQU8sQ0FBQyxTQUFTLEVBQUUsTUFBTSxDQUFDLENBQUM7WUFDL0IsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLFlBQVksRUFBRSxZQUFZLENBQUMsQ0FBQztRQUNoRCxDQUFDO0tBQ2lCLENBQUMsQ0FBQztJQUV0QixPQUFPLEVBQVksQ0FBQztBQUN0QixDQUFDLENBQUMsRUFBRSxDQUFDIn0=